var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButtonModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#864BFA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9990_35997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9990_35997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0008 16.4008L10.1008 21.3008C9.91745 21.4841 9.68411 21.5758 9.40078 21.5758C9.11745 21.5758 8.88411 21.4841 8.70078 21.3008C8.51745 21.1174 8.42578 20.8841 8.42578 20.6008C8.42578 20.3174 8.51745 20.0841 8.70078 19.9008L13.6008 15.0008L8.70078 10.1008C8.51745 9.91745 8.42578 9.68411 8.42578 9.40078C8.42578 9.11745 8.51745 8.88411 8.70078 8.70078C8.88411 8.51745 9.11745 8.42578 9.40078 8.42578C9.68411 8.42578 9.91745 8.51745 10.1008 8.70078L15.0008 13.6008L19.9008 8.70078C20.0841 8.51745 20.3174 8.42578 20.6008 8.42578C20.8841 8.42578 21.1174 8.51745 21.3008 8.70078C21.4841 8.88411 21.5758 9.11745 21.5758 9.40078C21.5758 9.68411 21.4841 9.91745 21.3008 10.1008L16.4008 15.0008L21.3008 19.9008C21.4841 20.0841 21.5758 20.3174 21.5758 20.6008C21.5758 20.8841 21.4841 21.1174 21.3008 21.3008C21.1174 21.4841 20.8841 21.5758 20.6008 21.5758C20.3174 21.5758 20.0841 21.4841 19.9008 21.3008L15.0008 16.4008Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButtonModal);
export default __webpack_public_path__ + "static/media/close-button-modal.7660648e8edaa10b678f77e9ace0baf2.svg";
export { ForwardRef as ReactComponent };